import * as types from "../constants/ActionTypes";

const initialState = {
  planningConfiguration: {},
  loading: false
}

export function fetchDealerPlanningConfiguration(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_DEALER_PLANNING_CONFIGURATION_SUCCESS:
      return {
        ...state,
        planningConfiguration: action.payload,
      };
    default:
      return state;
  }
}

export function saveDealerPlanningConfiguration(state = initialState, action) {
  switch (action.type) {
    case types.SAVE_DEALER_PLANNING_CONFIGURATION_SUCCESS:
      return {
        ...state,
        planningConfiguration: action.payload
      };
    default:
      return state;
  }
}
